export default __webpack_public_path__ + "static/media/link-green.8997d55b.d163093c.svg";